import { createRouter, createWebHashHistory } from 'vue-router'
import GetStarted from './components/GetStarted.vue'
import GallonWater from './components/products/GallonWater.vue'
import BottleFreeCooler from './components/products/BottleFreeCooler.vue'
import Products from './components/Products.vue'
import ProductDetail from './components/ProductDetail.vue'
import OrderSummary from './components/OrderSummary.vue'
import Checkout from './components/Checkout.vue'
import store from './store.js'

const routes = [
  { path: '/',                    name: 'home',               component: GetStarted },
  { path: '/gallon-water',        name: 'gallon-water',       component: GallonWater },
  { path: '/bottle-free-cooler',  name: 'bottle-free-cooler', component: BottleFreeCooler },
  { path: '/products',            name: 'products',           component: Products },
  { path: '/products/:productId', name: 'product-detail',     component: ProductDetail },
  { path: '/order-summary',       name: 'order-summary',      component: OrderSummary },
  { path: '/checkout',            name: 'checkout',           component: Checkout }
]

// Setup the router
const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

router.afterEach((to, from) => {
  store.dispatch('setPageMetaInfo')

  setTimeout(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }, 100)
})

export default router
